/* Primal Order (Druid 1, D&D 2024 / SRD 5.2.1), saved at `classState.druid.primalOrder` as { id }.
 * CommonJS like divineOrder.js: the spell limits and skill bonuses that read it are synchronous on both runtimes.
 */
const PRIMAL_ORDERS = Object.freeze([
  Object.freeze({ id: 'magician', name: 'Magician', summary: 'You know one extra Druid cantrip, and you add your Wisdom modifier (minimum +1) to Intelligence (Arcana or Nature) checks.' }),
  Object.freeze({ id: 'warden', name: 'Warden', summary: 'Trained for battle, you gain proficiency with Martial weapons and training with Medium armor.' }),
]);
const MAGICIAN_SKILLS = Object.freeze(['arcana', 'nature']);

const getPrimalOrder = (character) => PRIMAL_ORDERS.find((order) => order.id === character?.classState?.druid?.primalOrder?.id) || null;
/** Cantrips the order adds to the Druid's limit. */
const primalOrderCantrips = (character) => (getPrimalOrder(character)?.id === 'magician' ? 1 : 0);
/** What a Magician adds to this skill's check; 0 for anyone else and any other skill. */
const magicianSkillBonus = (character, skill, wisdomModifier) => (getPrimalOrder(character)?.id === 'magician' && MAGICIAN_SKILLS.includes(skill)
  ? Math.max(1, Math.floor(Number(wisdomModifier) || 0)) : 0);

module.exports = { PRIMAL_ORDERS, MAGICIAN_SKILLS, getPrimalOrder, primalOrderCantrips, magicianSkillBonus };
